import $ from '../core/Dom';

export default el => {
    const restartButton = $(el).find('[data-restart]');
    const questions = $(el).find('[data-question]');
    const result = $(el).find('[data-result]');
    const results = $(el).find('[data-results]');
    const radioButtons = $(el).find('input');

    const onRadioChange = e => {
        e.preventDefault();
        const checked = radioButtons.filter(':checked');
        if (checked.length === questions.length) {
            let total = 0;
            let done = false;
            checked.each(node => { total += parseInt(node.value, 10); });
            console.log('total', total);

            result.reverse().each(node => {
                if (!done && total >= parseInt(node.getAttribute('data-score'), 10)) {
                    $(node).css('display', 'block');
                    done = true;
                }
            });
            results.css('display', 'flex');
        }
    };

    const onRestart = e => {
        e.preventDefault();
        radioButtons.each(node => { node.checked = false; });
        result.attr('style', null);
        results.css('display', 'none');
    };

    const init = () => {
        radioButtons.on('change', onRadioChange);
        restartButton.on('click', onRestart);
    };

    const destroy = () => {
        radioButtons.off('change', onRadioChange);
        restartButton.off('click', onRestart);
    };

    return {
        init,
        destroy
    };
};
